(function() {
  // Store intervals in a WeakMap to avoid memory leaks
  const intervals = new WeakMap();
  const TIMER_INITIALIZED_FLAG = 'timer-initialized';

  function setupCountdownTimer(timerElement) {
    if (!timerElement || timerElement.getAttribute(TIMER_INITIALIZED_FLAG)) return;

    const expiresAt = timerElement.getAttribute('data-timer-date');
    if (!expiresAt) return;

    const endTime = new Date(expiresAt.replace(/-/g, '/'));
    startCountdownTimer(timerElement, endTime);
    timerElement.setAttribute(TIMER_INITIALIZED_FLAG, 'true');
  }

  function startCountdownTimer(timerElement, endTime) {
    // Clear any existing interval for this timer
    if (intervals.has(timerElement)) {
      clearInterval(intervals.get(timerElement));
    }

    function updateTimer() {
      let totalSeconds = Math.floor((endTime - new Date()) / 1000);

      if (totalSeconds <= 0 || !totalSeconds) {
        clearInterval(intervals.get(timerElement));
        intervals.delete(timerElement);
        totalSeconds = 0;
      }

      // Calculate time components
      const days = Math.floor(totalSeconds / (60 * 60 * 24));
      const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = Math.floor(totalSeconds % 60);

      // Update first container (days)
      const firstCounter = timerElement.querySelector('#first-counter');
      const firstText = timerElement.querySelector('#first-text');
      if (firstCounter) firstCounter.textContent = String(days).padStart(2, '0');
      if (firstText) firstText.textContent = 'Days';

      // Update second container (hours)
      const secondCounter = timerElement.querySelector('#second-counter');
      const secondText = timerElement.querySelector('#second-text');
      if (secondCounter) secondCounter.textContent = String(hours).padStart(2, '0');
      if (secondText) secondText.textContent = 'Hours';

      // Update third container (minutes)
      const thirdCounter = timerElement.querySelector('#third-counter');
      const thirdText = timerElement.querySelector('#third-text');
      if (thirdCounter) thirdCounter.textContent = String(minutes).padStart(2, '0');
      if (thirdText) thirdText.textContent = 'Minutes';

      // Update fourth container (seconds)
      const fourthCounter = timerElement.querySelector('#fourth-counter');
      const fourthText = timerElement.querySelector('#fourth-text');
      if (fourthCounter) fourthCounter.textContent = String(seconds).padStart(2, '0');
      if (fourthText) fourthText.textContent = 'Seconds';
    }

    // Start new interval for this timer
    updateTimer();
    intervals.set(timerElement, setInterval(updateTimer, 1000));
  }

  // Initialize all timers on DOM load
  function initializeTimers() {
    const timers = document.querySelectorAll('[data-timer-date]');
    timers.forEach(timer => {
      setupCountdownTimer(timer);
    });
  }

  // Initialize timer on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTimers);
  } else {
    initializeTimers();
  }

  // Handle Shopify section events
  document.addEventListener('shopify:section:load', (event) => {
    const timers = event.target.querySelectorAll('[data-timer-date]');
    timers.forEach(timer => {
      setupCountdownTimer(timer);
    });
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const timers = event.target.querySelectorAll('[data-timer-date]');
    timers.forEach(timer => {
      if (intervals.has(timer)) {
        clearInterval(intervals.get(timer));
        intervals.delete(timer);
      }
    });
  });
})(); 